import React from "react";
//Limitless imports
import { useNotificationContext } from "@limitless/common/hooks/notification/NotificationContext";
import Alert from "@limitless/modern/feedback/alert/Alert";
const Notifications = () => {
  const {
    notification,
    clearNotification
  } = useNotificationContext();
  return /*#__PURE__*/React.createElement(Alert, {
    description: notification.title,
    onClose: clearNotification,
    open: notification.title !== "",
    severity: notification.variant,
    duration: notification.duration,
    payload: notification.payload,
    showCloseIcon: true,
    title: notification.header
  });
};
export default Notifications;